// src/components/Settings.js
import React, { useState } from 'react';
import { Icons } from './Icons';

const settingsData = [
  { key: 'modchatID', name: 'Чат модерации', description: 'ID чата, куда будут отправляться репорты' },
  { key: 'commandCd', name: 'Задержка команд', description: 'Минимальное время между командами для пользователей (сек)' },
  { key: 'warnExpireTime', name: 'Срок снятия предупреждений', description: 'Формат: 5m, 2h, 3d, 1M' },
  { key: 'warnPunishmentCount', name: 'Лимит предупреждений', description: 'Количество предупреждений до наказания' },
  { key: 'warnPunishment.type', name: 'Тип наказания за варны', description: 'mute — запрет писать, ban — блокировка' },
  { key: 'warnPunishment.duration', name: 'Длительность наказания за варны', description: 'null — навсегда, или время (5m, 2h, 3d, 1M)' },
  { key: 'quickMuteDuration', name: 'Длительность быстрого мута', description: 'Мут через кнопку в репорте (5m, 2h, 3d, 1M)' },
  { key: 'autoComment', name: 'Авто-комментарий', description: 'Комментировать посты из канала' },
  { key: 'autoCommentText', name: 'Текст авто-комментария', description: 'Шаблон комментария к постам' },
  { key: 'autoCommentTextEnd', name: 'Концовка авто-комментария', description: 'Текст в конце комментария' },
  { key: 'allowKickme', name: 'Разрешить /kickme', description: 'Позволить пользователям выгонять себя' },
  { key: 'mediaRestrictionEnabled', name: 'Ограничение медиа', description: 'Временный запрет на медиа после авто-комментария' },
  { key: 'mediaRestrictionDuration', name: 'Длительность ограничения медиа', description: '2m, 1h, 1d, 1M' },
  { key: 'autoRaidMode', name: 'Автоматический антирейд', description: 'Автоматическое обнаружение массовых вступлений' },
  { key: 'raidSensitivity', name: 'Чувствительность антирейда', description: 'Уровень 1-5. 5 — для активных чатов' },
  { key: 'autoDeleteEnabled', name: 'Автоудаление сообщений бота', description: 'Автоматическая очистка сообщений бота' },
  { key: 'autoDeleteDuration', name: 'Время до автоудаления', description: '3m, 1h, 1d, 1M' },
  { key: 'welcomeMessageEnabled', name: 'Приветственное сообщение', description: 'Приветствие новых участников' },
  { key: 'welcomeMessageText', name: 'Текст приветствия', description: 'Используйте ?name для упоминания пользователя' },
  { key: 'captchaEnabled', name: 'Капча', description: 'Проверка капчи для новых участников' },
  { key: 'captchaType', name: 'Тип капчи', description: 'simple — кнопка, hard — математический пример' },
  { key: 'captchaKickEnabled', name: 'Автоисключение при капче', description: 'Исключать при непрохождении через 5 минут' },
  { key: 'autoMessageEnabled', name: 'Авто-сообщения', description: 'Автоматическая отправка сообщений' },
  { key: 'autoMessageInterval', name: 'Период авто-сообщений', description: '1h, 30m, 2d, 1M' },
  { key: 'autoMessageText', name: 'Текст авто-сообщений', description: 'До 6 сообщений через ~*~, каждое до 700 символов' }
];

function Settings() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredSettings = settingsData.filter(s => 
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.key.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section id="settings" className="settings">
      <div className="container">
        <div className="section-header">
          <h2>Настройки чата</h2>
          <p>Более 25 параметров для полного контроля</p>
        </div>
        <div className="settings-search">
          <input 
            type="text" 
            placeholder="Поиск настройки..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="settings-grid">
          {filteredSettings.map((setting, index) => (
            <div key={index} className="setting-card">
              <div className="setting-key">{setting.key}</div>
              <h4>{setting.name}</h4>
              <p>{setting.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Settings;